export function toUpperCase(target: string) {
	return target.toUpperCase();
}
